import React, { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { LanguageContext } from "../context/LanguageContext";
import ActivityList2 from "./activityList2";
import MachinesList1 from "./machineList";        // 👈 máquina obligatoria, sin depender de producto
import ShiftList2 from "./shiftList2";
import OperatorComboBox from "./operatorComboBox";
import { apiClient, createActivity } from "../api";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { es } from "date-fns/locale";
import { format } from "date-fns";

import ActListBut from "./actListBut";  // 👈 nuevo
// Respeta mayúsculas/minúsculas del nombre real del archivo
import ProdComboBoxByMachine from "./prodComboBoxByMachine";


const NewActForm = () => {
  const { t } = useContext(LanguageContext);
  const navigate = useNavigate();
  const handleGoBack = () => { navigate(-1); };

  const user = JSON.parse(localStorage.getItem("user"));
  const company = JSON.parse(localStorage.getItem("company"));

  // Igual que en NewBatchForm
  const formatTime = (date) => {
    if (!date) return null;
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    return `${hours}:${minutes}:00`; // MySQL TIME
  };

  // Estado
  const [idActivity, setIdActivity] = useState("");
  const [codMaq, setCodMaq] = useState(""); // obligatorio
  const [idProd, setIdProd] = useState(""); // opcional
  const [idshift, setIdShift] = useState(""); //obligatorio
  const [idoperator, setIdOperator] = useState(""); //optional

  const [fechaAct, setFechaAct] = useState(null); // Date
  const [timeIni, setTimeIni] = useState("");     // Date
  const [timeFin, setTimeFin] = useState("");     // Date
  const [observations, setObservations] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validaciones mínimas
    if (!idActivity) return alert(t("actTypeRequired") || "Debes seleccionar un tipo de actividad.");
    if (!codMaq) return alert(t("machineRequired") || "Debes seleccionar una máquina.");
    if (!idshift) return alert(t("machineRequired") || "Debes seleccionar un turno.");
    if (!fechaAct) return alert(t("dateRequired") || "Debes seleccionar la fecha.");
    if (!timeIni) return alert(t("startRequired") || "Debes seleccionar la hora de inicio.");
    if (!timeFin) return alert(t("endRequired") || "Debes seleccionar la hora de fin.");
    if (timeIni && timeFin && timeIni > timeFin) {
      return alert(t("endAfterStart") || "La hora de fin no puede ser menor que la hora de inicio.");
    }
    if (observations && observations.length > 300) {
      return alert(t("obsTooLong") || "Observaciones supera 300 caracteres.");
    }


    // Verifica que `idActivity` tenga un valor antes de enviarlo
    console.log("Data being sent:", {
      id_c: company.id_c,
      id_user: parseInt(user.id_u, 10),
      id_activity: idActivity,  // Aquí debe tener un valor
      cod_maq: codMaq,
      id_prod: idProd || null,
      id_shift: idshift,
      id_operator: idoperator || null,
      observations: observations || null,
      date_act: format(fechaAct, "yyyy-MM-dd"),
      time_begin: formatTime(timeIni),
      time_end: formatTime(timeFin),
    });


    //v2
    const payload = {
      id_user: parseInt(user.id_u, 10),

      cod_maq: codMaq,
      id_prod: idProd || null,
            id_operator: idoperator || null,
      id_activity: idActivity,
      id_shift: idshift,

      observations: observations || null,
      date_act: format(fechaAct, "yyyy-MM-dd"),
      time_begin: formatTime(timeIni),
      time_end: formatTime(timeFin),
    };

    try {
      const response = await createActivity(company.id_c, payload); // Usar la función createActivity
      alert(t("savedOk") || "✅ Actividad registrada exitosamente");
      handleGoBack();
    } catch (error) {
      console.error("❌ Error al registrar actividad:", error);
      alert(t("saveError") || "Ocurrió un error al registrar la actividad.");
    }
  };




  /*

    try {
      const data = {
        id_c: company.id_c,
        id_user: parseInt(user.id_u, 10),

        id_activity: idActivity,
        cod_maq: codMaq,
        id_prod: idProd || null,               // 👈 opcional

        observations: observations || null,
        date_act: format(fechaAct, "yyyy-MM-dd"),
        time_begin: formatTime(timeIni),
        time_end: formatTime(timeFin),
      };

      await apiClient.post(`/company/${company.id_c}/activity`, data);
      alert(t("savedOk") || "✅ Actividad registrada exitosamente");
      handleGoBack();
    } catch (error) {
      console.error("❌ Error al registrar actividad:", error);
      alert(t("saveError") || "Ocurrió un error al registrar la actividad.");
    }
  };
*/
  return (
    <div className="box1">
      <div className="box9">
        <form onSubmit={handleSubmit}>
          <table className="form1">
            <tbody>


              {/* Tipo de actividad (obligatorio) */}


              <tr>
                <td><label htmlFor="act_type">{t("actType2") || "Tipo de Actividad"}:</label></td>
                <td>
                  <ActivityList2
                    id_c={company.id_c}
                    value={idActivity}
                    onSelect={(v) => {
                      console.log("Selected activity:", v); // Verifica que el valor se pase correctamente
                      setIdActivity(v);
                    }}
                  />
                </td>
              </tr>



              {/* Shift  (obligatorio */}
              <tr>
                <td><label htmlFor="id_shift">{t("shifts1") || "Turno"}:</label></td>
                <td>
                  <ShiftList2
                    id_c={company.id_c}
                    value={idshift}
                    onSelect={(v) => setIdShift(v)}
                  />
                </td>
              </tr>


              {/* Operator  (obligatorio */}
              <tr>
                <td><label htmlFor="id_shift">{t("operator1") || "Operator"}:</label></td>
                <td>
                  <OperatorComboBox
                    id_c={company.id_c}
                    value={idoperator}
                    onSelect={(v) => setIdOperator(v)}
                  />
                </td>
              </tr>





              {/* Máquina (obligatorio, primero) */}
              <tr>
                <td><label htmlFor="cod_maquina">{t("batchList2") || "Código de Máquina"}:</label></td>
                <td>
                  <MachinesList1
                    id_c={company.id_c}
                    onSelect={(value) => setCodMaq(value)} // al cambiar, el ProdList se limpia solo
                  />
                </td>
              </tr>

              <tr>
                <td>
                  <label htmlFor="cod_producto">
                    {t("batchList3") || "Código Producto"} ({t("optional") || "opcional"}):
                  </label>
                </td>
                <td>
                  <ProdComboBoxByMachine
                    id_c={company.id_c}
                    cod_maq={codMaq}                 // 👈 filtra por máquina
                    value={idProd}
                    onSelect={(v) => setIdProd(v)}   // puede ser "" (sin producto)
                    placeholder="— Sin producto —"   // opción vacía
                  />
                </td>
              </tr>
              {/* Fecha */}
              <tr>
                <td><label htmlFor="fecha_act">{t("batchList7") || "Fecha"}:</label></td>
                <td>
                  <DatePicker
                    selected={fechaAct}
                    onChange={(date) => setFechaAct(date)}
                    dateFormat="yyyy-MM-dd"
                    locale={es}
                    placeholderText="AAAA-MM-DD"
                    className="input1"
                    id="fecha_act"
                    name="fecha_act"
                    required
                  />
                </td>
              </tr>

              {/* Hora inicio */}
              <tr>
                <td><label htmlFor="time_ini">{t("batchList8") || "Hora Inicio"}:</label></td>
                <td>
                  <DatePicker
                    selected={timeIni}
                    onChange={(date) => setTimeIni(date)}
                    showTimeSelect
                    showTimeSelectOnly
                    timeIntervals={5}
                    timeCaption="Hora"
                    dateFormat="HH:mm"
                    timeFormat="HH:mm"
                    locale={es}
                    placeholderText={t("selectHour") || "Selecciona hora"}
                    className="input1"
                    id="time_ini"
                    name="time_ini"
                    required
                  />
                </td>
              </tr>

              {/* Hora fin */}
              <tr>
                <td><label htmlFor="time_fin">{t("batchList10") || "Hora Fin"}:</label></td>
                <td>
                  <DatePicker
                    selected={timeFin}
                    onChange={(date) => setTimeFin(date)}
                    showTimeSelect
                    showTimeSelectOnly
                    timeIntervals={5}
                    timeCaption="Hora"
                    dateFormat="HH:mm"
                    timeFormat="HH:mm"
                    locale={es}
                    placeholderText={t("selectHour") || "Selecciona hora"}
                    className="input1"
                    id="time_fin"
                    name="time_fin"
                    required
                  />
                </td>
              </tr>

              {/* Observaciones */}
              <tr>
                <td><label htmlFor="observations">{t("observations") || "Observaciones"} ({t("optional") || "opcional"}):</label></td>
                <td>
                  <textarea
                    className="input1"
                    id="observations"
                    name="observations"
                    rows="3"
                    maxLength={300}
                    value={observations}
                    onChange={(e) => setObservations(e.target.value)}
                    placeholder={t("notes") || "Notas (máx 300)"}
                  />
                </td>
              </tr>
            </tbody>
          </table>

          <button type="submit" className="button7">{t("save") || "Guardar"}</button>
          <button type="button" className="button7" onClick={handleGoBack}>
            {t("cancel") || "Cancelar"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default NewActForm;
